import { render, staticRenderFns } from "./SecureDeleteDialog.vue?vue&type=template&id=42a9158f&scoped=true"
import script from "./SecureDeleteDialog.vue?vue&type=script&lang=ts"
export * from "./SecureDeleteDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a9158f",
  null
  
)

export default component.exports